// extracted by mini-css-extract-plugin
export default {"departments":"ZI-z","departmentHeading":"_I-z","departmentSection":"aJ-z","departmentName":"bJ-z","departmentLink":"cJ-z","expandIcon":"dJ-z"};